import React from 'react';
import RichTextBlock from '@op/components/RichTextBlock';
import { SubmitValueType } from '@op/components/RichTextBlock/RichTextEditModal';
import {
  useAiSummaryRichText,
  AiSummaryRichPropsType,
} from '../../hooks/useRichText';

import './index.scss';
interface InsightAnalysisProps extends AiSummaryRichPropsType {
  title?: string; // 传值则为独立模块, 默认为子模块
  className?: string;
}

export default function InsightAnalysis({
  title = '',
  filter,
  summary_type,
  RichModuleKey,
  className,
}: InsightAnalysisProps) {
  const { richText, modifyRichText, loading } = useAiSummaryRichText({
    filter,
    summary_type,
    RichModuleKey,
  });

  return (
    <RichTextBlock
      contentCard
      tabs={richText}
      isFull={false}
      loading={loading}
      loadingHeight={400}
      emptyHeight={400}
      emptyProps={{ height: 400 }}
      className={className}
      bodyStyle={{ padding: 22, borderRadius: 10 }}
      title={
        <div
          style={{ marginBottom: '20px' }}
          className="dbo-community-metrics-title  --link"
        >
          {title}
        </div>
      }
      onlyModalTitle
      onlyOneLanguage
      canEdit
      bodyHeight={400}
      onConfirm={(_item: SubmitValueType) => {
        const data = _item[0];
        return modifyRichText({
          id: Number(data.key),
          content: data.text,
        });
      }}
    ></RichTextBlock>
  );
}
